export default [
  {
    url: "/back",
    name: "분야 바로가기",
    icon: "ArrowLeftIcon",
    activeCode: "",
  },
  {
    url: "/home",
    name: "대시보드",
    icon: "",
    activeCode: "",
  },
  // {
  //   url: "/tab/118/page",
  //   name: "시스템 계약 현황",
  //   icon: "",
  //   activeCode: "",
  //   groupName: ["118"],
  // },
  // {
  //   url: "/",
  //   name: "신규 사업장 등록 요청",
  //   icon: "",
  //   activeCode: "",
  //   submenu: [
  //     {
  //       url: "/tab/300",
  //       name: "직영사업장",
  //       icon: "w-line",
  //       activeCode: "",
  //       groupName: ["300"],
  //     },
  //   ],
  // },
  {
    url: "/",
    name: "사업장 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/field/workplace-insider",
        name: "직영사업장",
        icon: "w-line",
        activeCode: "field-workplace-insider",
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건조직체계",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/453",
        name: "안전·보건 조직체계도(총괄)",
        icon: "w-line",
        activeCode: "",
        groupName: ["453"],
      },
      {
        url: "/tab/282",
        name: "안전보건관리책임자 선임",
        icon: "w-line",
        activeCode: "",
        groupName: ["282"],
      },
      {
        url: "/tab/594",
        name: "안전보건총괄책임자 선임",
        icon: "w-line",
        activeCode: "",
        groupName: ["594"],
      },
      {
        url: "/tab/297",
        name: "관리감독자 선임",
        icon: "w-line",
        activeCode: "",
        groupName: ["297"],
      },
      {
        url: "/tab/126",
        name: "안전·보건 조직 체계도",
        icon: "w-line",
        activeCode: "",
        groupName: ["126"],
      },
      {
        url: "/tab/553",
        name: "종사자 정보",
        icon: "w-line",
        activeCode: "",
        groupName: ["553"],
      },
      // {
      //   url: '/company/info',
      //   name: '소속부서 및 담당업체 정보',
      //   icon: 'w-line',
      //   activeCode: 'company-info',
      // },
      // {
      //   url: '/tab/141',
      //   name: '안전보건 관련 인력',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['141'],
      // },
      // {
      //   url: '/tab/136',
      //   name: '안전보건 점검 인력',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['136'],
      // },
      // {
      //   url: "/tab/299",
      //   name: "종사자 정보",
      //   icon: "w-line",
      //   activeCode: "",
      //   groupName: ["299"],
      // },
      // {
      //   url: '/tab/138',
      //   name: '비상 연락/지원 체계도',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['138'],
      // },
      {
        url: "/tab/436",
        name: "유관기관 비상연락망",
        icon: "w-line",
        activeCode: "",
        groupName: ["436"],
      },
      // {
      //   url: '/tab/119',
      //   name: '안전보건관리 책임자 지정 외',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['119', '120', '121', '122', '123', '125'],
      // },
      {
        url: "/tab/140",
        name: "안전·보건관리체계 구축 현황(중대산업재해)",
        icon: "w-line",
        activeCode: "",
        groupName: ["140"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건관리 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/398",
        name: "안전보건 일정표",
        icon: "w-line",
        activeCode: "",
        groupName: ["398"],
      },
      {
        url: "/tab/137",
        name: "안전·보건 점검 계획",
        icon: "w-line",
        activeCode: "",
        groupName: ["137"],
      },
      {
        url: "/tab/101",
        name: "안전·보건 경영방침",
        icon: "w-line",
        groupName: ["101"],
      },
      // {
      //   url: '/tab/109',
      //   name: '사업장 안전·보건 경영방침',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['109'],
      // },
      {
        url: "/",
        name: "중대재해예방 점검",
        icon: "w-line",
        activeCode: "",
        submenu: [
          {
            url: "/tab/558",
            name: "안전보건 의무 이행점검 및 평가･개선 점검표(중대산업재해)",
            icon: "w-line",
            activeCode: "",
            groupName: ["558"],
          },
          {
            url: "/tab/559",
            name: "안전보건 의무 이행점검 및 평가･개선 점검표(중대시민재해)",
            icon: "w-line",
            activeCode: "",
            groupName: ["559"],
          },
        ],
      },
      {
        url: "/tab/286",
        name: "안전보건관리책임자 업무수행평가표",
        icon: "w-line",
        activeCode: "",
        groupName: ["286"],
      },
      {
        url: "/tab/557",
        name: "안전보건총괄책임자 업무수행평가표",
        icon: "w-line",
        activeCode: "",
        groupName: ["557"],
      },
      {
        url: "/tab/287",
        name: "관리감독자 업무수행평가표",
        icon: "w-line",
        activeCode: "",
        groupName: ["287"],
      },
      {
        url: "/tab/130",
        name: "수급업체 수행평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["130"],
      },
      {
        url: "/tab/129",
        name: "종사자 참여 평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["129"],
      },
      // {
      //   url: '/tab/130',
      //   name: '수행평가',
      //   icon: 'w-line',
      //   activeCode: '',
      //   groupName: ['129', '130'],
      // },
      {
        url: "/tab/131",
        name: "수시 점검표",
        icon: "w-line",
        activeCode: "",
        groupName: ["131"],
      },
      {
        url: "/tab/150",
        name: "안전·보건 확보 의무",
        icon: "w-line",
        activeCode: "",
        groupName: ["150"],
      },
      {
        url: "/tab/152",
        name: "산업안전보건위원회",
        icon: "w-line",
        activeCode: "",
        groupName: ["152"],
      },
    ],
  },
  {
    url: "/",
    name: "(시설물)유해·위험요인 점검 및 개선 계획",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/379",
        name: "(시설물)유해·위험요인 개선 계획",
        icon: "w-line",
        activeCode: "",
        groupName: ["379"],
      },
      {
        url: "/tab/382",
        name: "(사업장)유해·위험요인 개선 계획",
        icon: "w-line",
        activeCode: "",
        groupName: ["382"],
      },
      {
        url: "/tab/380",
        name: "(부서별 관리 시설물)유해·위험요인 개선 계획",
        icon: "w-line",
        activeCode: "",
        groupName: ["380"],
      },
      {
        url: "/tab/383",
        name: "(부서별 관리 사업장)유해·위험요인 개선 계획",
        icon: "w-line",
        activeCode: "",
        groupName: ["383"],
      },
      {
        url: "/tab/381",
        name: "(위탁 시설물)유해·위험요인 개선 계획",
        icon: "w-line",
        activeCode: "",
        groupName: ["381"],
      },
      {
        url: "/tab/384",
        name: "(수급업체 사업장)유해·위험요인 개선 계획",
        icon: "w-line",
        activeCode: "",
        groupName: ["384"],
      },
    ],
  },
  {
    url: "/",
    name: "건강진단",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/501",
        name: "일반건강진단",
        icon: "w-line",
        activeCode: "",
        groupName: ["501"],
      },
      {
        url: "/tab/318",
        name: "특수건강진단",
        icon: "w-line",
        activeCode: "",
        groupName: ["318"],
      },
      {
        url: "/tab/507",
        name: "산업보건의 활동실적(연도별)",
        icon: "w-line",
        activeCode: "",
        groupName: ["507"],
      },
      {
        url: "/tab/361",
        name: "요관찰자·유소견자 사후관리",
        icon: "w-line",
        activeCode: "",
        groupName: ["361"],
      },
      {
        url: "/tab/_361/page",
        name: "요관찰자·유소견자 건강 상담 실적 통계",
        icon: "w-line",
        activeCode: "",
        groupName: ["361/page"],
      },
      {
        url: "/tab/660",
        name: "사후관리 안내문",
        icon: "w-line",
        activeCode: "",
        groupName: ["660"],
      },
      {
        url: "/tab/364",
        name: "일정 관리",
        icon: "w-line",
        activeCode: "",
        groupName: ["364"],
      },
      {
        url: "/tab/399",
        name: "화학물질 관리대장",
        icon: "w-line",
        activeCode: "",
        groupName: ["399"],
      },
      {
        url: "/tab/400",
        name: "화학물질(작업환경측정 대상) 취급대장",
        icon: "w-line",
        activeCode: "",
        groupName: ["400"],
      },
      {
        url: "/tab/365",
        name: "의약품 지급 현황",
        icon: "w-line",
        activeCode: "",
        groupName: ["365"],
      },
      {
        url: "/tab/366",
        name: "의료기구 점검현황",
        icon: "w-line",
        activeCode: "",
        groupName: ["366"],
      },
      {
        url: "/tab/checkCerebrovascular",
        name: "뇌·심발병도 평가",
        icon: "w-line",
        activeCode: "",
        onlySystemAdmin: true,
        groupName: ["checkCerebrovascular", "368", "369"],
      },
      {
        url: "/tab/370",
        name: "관련자료",
        icon: "w-line",
        activeCode: "",
        groupName: ["370"],
      },
    ],
  },
  {
    url: "/",
    name: "작업환경측정",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/659",
        name: "작업환경측정결과(연도별)",
        icon: "w-line",
        activeCode: "",
        groupName: ["659"],
      },
      {
        url: "/tab/_518/page",
        name: "작업환경측정결과총괄(연도별)",
        icon: "w-line",
        activeCode: "",
        groupName: ["518/page"],
      },
      {
        url: "/tab/585",
        name: "작업환경 개선조치",
        icon: "w-line",
        activeCode: "",
        groupName: ["585"],
      },
    ],
  },
  {
    url: "/",
    name: "근골격계",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/292",
        name: "근골격계 증상조사표(근로자)",
        icon: "w-line",
        activeCode: "",
        groupName: ["292"],
      },
      {
        url: "/tab/293",
        name: "근골격계부담작업 체크리스트",
        icon: "w-line",
        activeCode: "",
        groupName: ["293"],
      },
      {
        url: "/tab/597",
        name: "근골격계 유해요인조사표",
        icon: "w-line",
        activeCode: "",
        groupName: ["597"],
      },
      {
        url: "/tab/396",
        name: "근골격계 작업환경 개선 계획서",
        icon: "w-line",
        activeCode: "",
        groupName: ["396"],
      },
      {
        url: "/tab/586",
        name: "근골격계 작업환경 개선조치 결과서",
        icon: "w-line",
        activeCode: "",
        groupName: ["586"],
      },
      {
        url: "/tab/607",
        name: "결과보고서",
        icon: "w-line",
        activeCode: "",
        groupName: ["607"],
      },
    ],
  },
  {
    url: "/",
    name: "밀폐공간",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/658",
        name: "밀폐공간 현황",
        icon: "w-line",
        activeCode: "",
        groupName: ["658"],
      },
      {
        url: "/tab/566",
        name: "밀폐공간 작업 프로그램 매뉴얼",
        icon: "w-line",
        activeCode: "",
        groupName: ["566"],
      },
      {
        url: "/tab/567",
        name: "작업 후 서류(작업허가서 등)",
        icon: "w-line",
        activeCode: "",
        groupName: ["567"],
      },
      {
        url: "/tab/568",
        name: "프로그램 평가표",
        icon: "w-line",
        activeCode: "",
        groupName: ["568"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건 예산",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/106",
        name: "안전·보건 예산(A형)",
        icon: "w-line",
        activeCode: "",
        groupName: ["106"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건 교육",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/552",
        name: "안전·보건 교육",
        icon: "w-line",
        activeCode: "",
        groupName: ["552"],
      },
      {
        url: "/tab/132/page",
        name: "교육 모니터링",
        icon: "w-line",
        activeCode: "",
        groupName: ["132"],
      },
    ],
  },
  {
    url: "/",
    name: "유해·위험요인 관리",
    icon: "",
    activeCode: "",
    submenu: [
      // {
      //   url: "/tab/108",
      //   name: "유해·위험요인 조사표",
      //   icon: "w-line",
      //   activeCode: "",
      //   groupName: ["108", "156", "157", "158", "159", "305", "306"],
      // },
      {
        url: "/tab/554",
        name: "유해·위험방지 기계 기구",
        icon: "w-line",
        activeCode: "",
        groupName: ["554"],
      },
      {
        url: "/tab/305",
        name: "안전검사 대상 기계 기구",
        icon: "w-line",
        activeCode: "",
        groupName: ["305"],
      },
      {
        url: "/tab/160",
        name: "유해·위험요인 점검(개선)사항 요청",
        icon: "w-line",
        activeCode: "",
        groupName: ["160"],
      },
    ],
  },
  {
    url: "/",
    name: "위험성평가",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/288",
        name: "유해·위험발굴 현장순회점검일지",
        icon: "w-line",
        activeCode: "",
        groupName: ["288"],
      },
      {
        url: "/tab/161",
        name: "정기 위험성평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["161"],
      },
      {
        url: "/tab/riskresult",
        name: "정기 위험성평가 결과",
        icon: "w-line",
        activeCode: "",
        groupName: ["608", "609", "riskresult", "riskproposal"],
      },
      {
        url: "/tab/162",
        name: "수시 위험성평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["162"],
      },
      {
        url: "/tab/151",
        name: "위험성평가협의회",
        icon: "w-line",
        activeCode: "",
        groupName: ["151"],
      },
    ],
  },
  {
    url: "/",
    name: "안전작업계획(허가)",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/401",
        name: "안전작업계획서(장비작업)",
        icon: "w-line",
        activeCode: "",
        groupName: ["401"],
      },
      {
        url: "/tab/569",
        name: "안전작업계획서(고위험작업)",
        icon: "w-line",
        activeCode: "",
        groupName: ["569"],
      },
      {
        url: "/tab/663",
        name: "작업허가서",
        icon: "w-line",
        activeCode: "",
        groupName: ["663"],
      },
    ],
  },
  {
    url: "/",
    name: "안전·보건 점검",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/100",
        name: "작업장 합동 순회점검표",
        icon: "w-line",
        activeCode: "",
        groupName: ["100"],
      },
      {
        url: "/tab/564",
        name: "안전보건 순회점검표",
        icon: "w-line",
        activeCode: "",
        groupName: ["564"],
      },
      {
        url: "/tab/560",
        name: "관리감독자 점검표",
        icon: "w-line",
        activeCode: "",
        groupName: ["560"],
      },
      {
        url: "/tab/561",
        name: "온열·한랭질환 안전점검표",
        icon: "w-line",
        activeCode: "",
        groupName: ["561"],
      },
      {
        url: "/tab/397",
        name: "MSDS(물질안전보건자료)",
        icon: "w-line",
        activeCode: "",
        groupName: ["397"],
      },
      {
        url: "/tab/168",
        name: "시설물 관리(공통)",
        icon: "w-line",
        activeCode: "",
        groupName: ["168"],
      },

      {
        url: "/tab/377",
        name: "TBM(작업 전 안전점검회의)",
        icon: "w-line",
        activeCode: "",
        groupName: ["377"],
      },
      {
        url: "/tab/378",
        name: "TBM 실행 체크리스트",
        icon: "w-line",
        activeCode: "",
        groupName: ["378"],
      },
      {
        url: "/tab/402",
        name: "안전·보건 순회점검 결과서",
        icon: "w-line",
        activeCode: "",
        groupName: ["402"],
      },
      {
        url: "/tab/291",
        name: "안전 순회점검표(현장)",
        icon: "w-line",
        activeCode: "",
        groupName: ["291"],
      },
      {
        url: "/tab/290",
        name: "보건 순회점검표(현장)",
        icon: "w-line",
        activeCode: "",
        groupName: ["290"],
      },
      {
        url: "/tab/296",
        name: "동청사 안전점검표",
        icon: "w-line",
        activeCode: "",
        groupName: ["296"],
      },
      {
        url: "/tab/198",
        name: "계절성 업무에 따른 관리대책",
        icon: "w-line",
        activeCode: "",
        groupName: ["198"],
      },
      {
        url: "/tab/438",
        name: "휴게시설 주요 체크리스트",
        icon: "w-line",
        activeCode: "",
        groupName: ["438"],
      },
    ],
  },
  {
    url: "/",
    name: "재해발생 대비 대책",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/116/page",
        name: "(재해발생) 산업재해 발생 시 보고 절차 안내",
        icon: "w-line",
        activeCode: "",
        groupName: ["116"],
      },
      {
        url: "/tab/238/page",
        name: "(재해발생) 비상조치 및 처리 절차 안내",
        icon: "w-line",
        activeCode: "",
        groupName: ["238"],
      },
      {
        url: "/tab/239",
        name: "비상대피 훈련·교육·자체평가",
        icon: "w-line",
        activeCode: "",
        groupName: ["239", "240", "241"],
      },
      {
        url: "/tab/606",
        name: "중대산업재해 발생 대비 매뉴얼",
        icon: "w-line",
        activeCode: "",
        groupName: ["606"],
      },
      {
        url: "/tab/242",
        name: "비상조치계획 수립",
        icon: "w-line",
        activeCode: "",
        groupName: ["242"],
      },
    ],
  },
  {
    url: "/",
    name: "도급산업재해예방관리",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/163",
        name: "작업장 순회점검 (주1회)",
        icon: "w-line",
        activeCode: "",
        groupName: ["163"],
      },
      {
        url: "/tab/563",
        name: "안전보건협의체 (월1회)",
        icon: "w-line",
        activeCode: "",
        groupName: ["563"],
      },
      {
        url: "/tab/562",
        name: "합동안전보건점검 (분기1회)",
        icon: "w-line",
        activeCode: "",
        groupName: ["562"],
      },
    ],
  },
  {
    url: "/",
    name: "재해발생보고",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/117",
        name: "산업재해조사표",
        icon: "w-line",
        activeCode: "",
        groupName: ["117"],
      },
      {
        url: "/tab/244",
        name: "중대재해 발생 보고",
        icon: "w-line",
        activeCode: "",
        groupName: ["244"],
      },
      {
        url: "/tab/245",
        name: "재발방지계획서",
        icon: "w-line",
        activeCode: "",
        groupName: ["245"],
      },
      // {
      //   url: "/tab/346",
      //   name: "중대재해 발생 보고(제조업)",
      //   icon: "w-line",
      //   activeCode: "",
      //   groupName: ["346"],
      // },
      {
        url: "/tab/307",
        name: "안전사고 발생 보고서",
        icon: "w-line",
        activeCode: "",
        groupName: ["307"],
      },
      {
        url: "/tab/308",
        name: "재발방지 조치 보고서",
        icon: "w-line",
        activeCode: "",
        groupName: ["308"],
      },
    ],
  },
  {
    url: "/",
    name: "자료실",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/filelibrary/341",
        name: "자료실",
        activeCode: "filelibrary-341",
        icon: "w-line",
      },
      {
        url: "/",
        name: "현업",
        icon: "w-line",
        activeCode: "",
        submenu: [
          {
            url: "/filelibrary/545",
            name: "청소",
            activeCode: "filelibrary-545",
            icon: "w-line",
            groupName: ["545"],
          },
          {
            url: "/filelibrary/546",
            name: "환경미화",
            activeCode: "filelibrary-546",
            icon: "w-line",
            groupName: ["546"],
          },
          {
            url: "/filelibrary/547",
            name: "경비",
            activeCode: "filelibrary-547",
            icon: "w-line",
            groupName: ["547"],
          },
          {
            url: "/filelibrary/548",
            name: "시설물 유지관리",
            activeCode: "filelibrary-548",
            icon: "w-line",
            groupName: ["548"],
          },
          {
            url: "/filelibrary/549",
            name: "공원녹지",
            activeCode: "filelibrary-549",
            icon: "w-line",
            groupName: ["549"],
          },
          {
            url: "/filelibrary/550",
            name: "조리시설",
            activeCode: "filelibrary-550",
            icon: "w-line",
            groupName: ["550"],
          },
          {
            url: "/filelibrary/551",
            name: "기타",
            activeCode: "filelibrary-551",
            icon: "w-line",
            groupName: ["551"],
          },
        ],
      },
    ],
  },
  {
    url: "/community",
    name: "커뮤니티",
    slug: "community",
    icon: "",
    submenu: [
      {
        url: "/community/businessnews",
        name: "기관장 메세지",
        activeCode: "community_businessnews",
        icon: "w-line",
        groupName: ["16"],
      },
      {
        url: "/community/healthinfo",
        name: "안전보건 주요 일정",
        activeCode: "community_healthinfo",
        icon: "w-line",
        groupName: ["18"],
      },
      {
        url: "/community/unitbusinessnews",
        name: "구성원 요청사항",
        activeCode: "community_unitbusinessnews",
        icon: "w-line",
        groupName: ["19"],
      },
      {
        url: "/community/qna",
        name: "Q&A",
        activeCode: "community_qna",
        icon: "w-line",
        groupName: ["17"],
      },
    ],
  },
  {
    url: "/mypage",
    name: "마이페이지",
    slug: "safety",
    icon: "",
    submenu: [
      {
        url: "/mypage/workstatus",
        name: "업무현황",
        slug: "",
        icon: "w-line",
        groupName: ["90"],
      },
      {
        url: "/mypage/alert",
        name: "알림",
        slug: "",
        icon: "w-line",
        groupName: ["91"],
      },
      {
        url: "/",
        name: "결재관리",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/approval-request",
            name: "결재요청함",
            slug: "",
            icon: "w-line",
            groupName: ["93"],
          },
          {
            url: "/approval-await",
            name: "결재대기함",
            slug: "",
            icon: "w-line",
            groupName: ["94"],
          },
          {
            url: "/approval-process",
            name: "결재진행함",
            slug: "",
            icon: "w-line",
            groupName: ["95"],
          },
          {
            url: "/approval-complete",
            name: "완료문서함",
            slug: "",
            icon: "w-line",
            groupName: ["96"],
          },
          {
            url: "/approval-reject",
            name: "반려문서함",
            slug: "",
            icon: "w-line",
            groupName: ["97"],
          },
          {
            url: "/approval-reference",
            name: "참조/회람문서함",
            slug: "",
            icon: "w-line",
            groupName: ["98"],
          },
        ],
      },
      {
        url: "/",
        name: "설정",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/mypage/info-update",
            name: "개인정보변경",
            slug: "",
            icon: "w-line",
            groupName: ["92"],
          },
        ],
      },
    ],
  },
];
